module.exports = __webpack_public_path__ + "img/44.729ed9f2.jpg";